// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Content_content-container__42OER {
  background-color: var(--m-background-color);
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 16px;
}
.Content_content-container__42OER .Content_logo__jPNC0 {
  width: 100%;
  display: flex;
  justify-content: center;
}
.Content_content-container__42OER .Content_logo__jPNC0 img {
  width: 130px;
}
.Content_content-container__content__XBTW5 {
  display: flex;
  flex-direction: column;
  width: 400px;
  height: auto;
  padding: 16px 40px;
  box-sizing: border-box;
  color: rgb(94, 108, 132);
  background-color: var(--m-white);
  box-shadow: var(--m-box-shadow);
  border-radius: var(--m-border-radius);
}
.Content_content-container__content__XBTW5 .Content_title__Ybmrg {
  width: 100%;
  display: flex;
  justify-content: center;
}
.Content_content-container__content__XBTW5 .Content_title__Ybmrg span {
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: rgb(23, 43, 77);
}

@media (max-width: 480px) {
  .Content_content-container__content__XBTW5 {
    width: 320px;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/auth/Content/Content.module.scss"],"names":[],"mappings":"AAAA;EACI,2CAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;AACJ;AACI;EACI,WAAA;EACA,aAAA;EACA,uBAAA;AACR;AACQ;EACI,YAAA;AACZ;AAGI;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,gCAAA;EACA,+BAAA;EACA,qCAAA;AADR;AAGQ;EACI,WAAA;EACA,aAAA;EACA,uBAAA;AADZ;AAGY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AADhB;;AAOA;EAEQ;IACI,YAAA;EALV;AACF","sourcesContent":[".content-container {\n    background-color: var(--m-background-color);\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 16px;\n\n    .logo {\n        width: 100%;\n        display: flex;\n        justify-content: center;\n\n        img {\n            width: 130px;\n        }\n    }\n\n    &__content {\n        display: flex;\n        flex-direction: column;\n        width: 400px;\n        height: auto;\n        padding: 16px 40px;\n        box-sizing: border-box;\n        color: rgb(94, 108, 132);\n        background-color: var(--m-white);\n        box-shadow: var(--m-box-shadow);\n        border-radius: var(--m-border-radius);\n\n        .title {\n            width: 100%;\n            display: flex;\n            justify-content: center;\n            \n            span {\n                font-weight: 500;\n                font-size: 16px;\n                line-height: 20px;\n                color: rgb(23, 43, 77);\n            }\n        }\n    }\n}\n\n@media (max-width: 480px) {\n    .content-container { \n        &__content {\n            width: 320px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content-container": `Content_content-container__42OER`,
	"logo": `Content_logo__jPNC0`,
	"content-container__content": `Content_content-container__content__XBTW5`,
	"title": `Content_title__Ybmrg`
};
export default ___CSS_LOADER_EXPORT___;
